__turbopack_context__.v({
  "BottomLeft": "Cta-module-sass-module__6SARdG__BottomLeft",
  "Cont": "Cta-module-sass-module__6SARdG__Cont",
  "Content": "Cta-module-sass-module__6SARdG__Content",
  "Copy": "Cta-module-sass-module__6SARdG__Copy",
  "Cta": "Cta-module-sass-module__6SARdG__Cta",
  "Dark": "Cta-module-sass-module__6SARdG__Dark",
  "HideMainTopBorder": "Cta-module-sass-module__6SARdG__HideMainTopBorder",
  "Image": "Cta-module-sass-module__6SARdG__Image",
  "Main": "Cta-module-sass-module__6SARdG__Main",
  "NoClipPaths": "Cta-module-sass-module__6SARdG__NoClipPaths",
  "Reverse": "Cta-module-sass-module__6SARdG__Reverse",
  "TopLeft": "Cta-module-sass-module__6SARdG__TopLeft",
  "bems": "Cta-module-sass-module__6SARdG__bems",
});
